"use client";

import { usePathname } from "next/navigation";

import { PAGES_TO_INDEX } from "@/internals/constants/paths";
import { isClient } from "@/utils/browser";
import { getSiteUrl } from "@/utils/site";

export const SEO = () => {
  const CURRENT_URL = getSiteUrl();
  const pathname = usePathname();

  const getCanonical = (path: string) => {
    const fullURL = new URL(path, CURRENT_URL);
    return `${fullURL.origin}${fullURL.pathname}`;
  };

  const canonical = getCanonical(pathname);

  let path = isClient() ? (pathname === "/" ? "/index" : pathname) : undefined;

  const isPageIndexed =
    process.env.NEXT_PUBLIC_ENV === "prod" && PAGES_TO_INDEX.includes(path);

  return (
    <head>
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={isPageIndexed ? "index,follow" : "noindex,nofollow"}
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
    </head>
  );
};
